var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" Date: "),_c('i',[_vm._v(_vm._s(_vm._f("formatDateTime")(_vm.marketplace.createdAt))+" ")])]),_c('br'),_c('span',[_vm._v("Marketplace: "),_c('i',[_vm._v(_vm._s(_vm.marketplace.marketPlace.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }